var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',_vm._l((_vm.cols),function(col){return _c('header-cell',{key:col.key,attrs:{"col":col}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }